"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProfileUpdateForm = _interopRequireDefault(require("../../components/ProfileUpdateForm"));
var _store = _interopRequireDefault(require("store"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "state", {
      message: null,
      url: null
    });
    _defineProperty(_this, "componentDidMount", function () {
      var logoutMessage = _store["default"].get('cccisd_logout_message');
      var logoutUrl = _store["default"].get('cccisd_logout_url');
      var logoutTime = _store["default"].get('cccisd_logout_time');
      _store["default"].remove('cccisd_logout_message');
      _store["default"].remove('cccisd_logout_url');
      _store["default"].remove('cccisd_logout_time');
      var currentTime = Date.now();
      // If logout is less than 1 minute ago
      if (logoutTime && currentTime - logoutTime < 60 * 1000) {
        _this.setState({
          message: logoutMessage,
          url: logoutUrl
        });
      }
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      // only valid if acting pawn has a user
      if (Fortress.user.acting.user === null) {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }
      var pawnId = Fortress.user.acting.id;
      var pawnHash = Fortress.user.acting.random_hash;
      if (Object.prototype.hasOwnProperty.call(this.props, 'match')) {
        if (Object.prototype.hasOwnProperty.call(this.props.match, 'params')) {
          if (Object.prototype.hasOwnProperty.call(this.props.match.params, 'pawnId') && this.props.match.params.pawnId !== undefined) {
            pawnId = this.props.match.params.pawnId;
          }
          if (Object.prototype.hasOwnProperty.call(this.props.match.params, 'pawnHash') && this.props.match.params.pawnHash !== undefined) {
            pawnHash = this.props.match.params.pawnHash;
          }
        }
      }
      var onSuccess = this.state.url ? function () {
        window.location = _this2.state.url;
      } : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Update Profile"), this.state.message && /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info ".concat(_style["default"].message)
      }, this.state.message), /*#__PURE__*/_react["default"].createElement(_ProfileUpdateForm["default"], {
        onSuccess: onSuccess,
        pawnId: pawnId,
        pawnHash: pawnHash,
        includePawnFields: true,
        includeUserFields: true,
        includePasswordFields: false
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  match: _propTypes["default"].object
});